module.exports = __webpack_public_path__ + "static/media/contact-bg.4d52eae5.jpg";